
import React from 'react';
import { Menu, ChevronRight, ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SidebarHeaderProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isOpen, toggleSidebar }) => {
  return (
    <div className="flex h-16 items-center justify-between px-6 border-b border-sidebar-border/30">
      <div className={cn("flex items-center", isOpen ? "" : "justify-center w-full")}>
        {isOpen ? (
          <img
            src="/logo.png"
            alt="ChipChip ERP"
            className="h-9 w-auto object-contain hover:scale-105 transition-transform duration-300 cursor-pointer"
          />
        ) : (
          <img
            src="/logo-icon.png"
            alt="CS"
            className="h-9 w-9 object-contain hover:rotate-12 transition-transform duration-300 cursor-pointer"
          />
        )}
      </div>

      {isOpen && (
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleSidebar}
          className="text-sidebar-foreground hover:bg-harvest-primary/10 hover:text-harvest-primary h-8 w-8 rounded-lg transition-colors"
          title="Collapse sidebar"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default SidebarHeader;
